import React from 'react';
import { Box, Typography } from '@mui/material';
import { FormSection } from '../../form/FormSection';
import { OptionCard } from '../../form/OptionCard';
import { FORM_SECTIONS, SERVICE_OPTIONS } from '../../../config/formSections';
import { FORM_STYLES } from '../../../styles/formStyles';
import { FormValues } from '../CreateStep1V3';

interface IncludedServicesSectionProps {
  values: FormValues;
  handleChange: (name: string) => (value: any) => void;
}

export const IncludedServicesSection: React.FC<IncludedServicesSectionProps> = ({
  values,
  handleChange
}) => {
  const sectionConfig = FORM_SECTIONS.includedServices;

  const essentialServices = Object.entries(SERVICE_OPTIONS).filter(
    ([_, config]) => config.category === 'essential'
  );

  const extraServices = Object.entries(SERVICE_OPTIONS).filter(
    ([_, config]) => config.category === 'extra'
  );

  const getServiceValue = (serviceKey: string): boolean | null => {
    const fieldMap: Record<string, keyof FormValues> = {
      heating: 'heatingIncluded',
      hotWater: 'hotWaterIncluded',
      electricity: 'electricityIncluded',
      internet: 'internetIncluded',
      parking: 'parkingIncluded',
      furniture: 'furnitureIncluded'
    };
    
    return values[fieldMap[serviceKey]] as boolean | null;
  };

  const handleServiceChange = (serviceKey: string) => (value: boolean) => {
    const fieldMap: Record<string, string> = {
      heating: 'heatingIncluded',
      hotWater: 'hotWaterIncluded',
      electricity: 'electricityIncluded',
      internet: 'internetIncluded',
      parking: 'parkingIncluded',
      furniture: 'furnitureIncluded'
    };
    
    handleChange(fieldMap[serviceKey])(value);
  };

  // Combine all services into one array for 3x2 grid
  const allServices = [...essentialServices, ...extraServices];

  return (
    <FormSection
      icon={sectionConfig.icon}
      iconColor={sectionConfig.color}
      title={sectionConfig.titleKey}
    >
      {/* 3x2 Grid Layout */}
      <Box sx={{ 
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' },
        gridTemplateRows: 'repeat(2, 1fr)',
        gap: 3,
        mt: 2
      }}>
        {allServices.map(([serviceKey, serviceConfig]) => (
          <Box key={serviceKey} sx={{ 
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
            <OptionCard
              icon={serviceConfig.icon}
              iconColor={serviceConfig.iconColor}
              iconBgColor={serviceConfig.color}
              title={serviceConfig.title}
              value={getServiceValue(serviceKey)}
              onChange={handleServiceChange(serviceKey)}
              sx={{ 
                width: '100%',
                minHeight: '120px',
                maxWidth: '200px'
              }}
              showInfoWhenYes={serviceKey === 'furniture'}
              infoText="Inventarielista för möbler och inventarier"
              infoLink="https://firebasestorage.googleapis.com/v0/b/hyria-58020.appspot.com/o/pdf%2Fmo%CC%88bler%20inventarier.pdf?alt=media&token=eda7ecff-c3ff-4202-ae5c-d270bbb67520"
            />
          </Box>
        ))}
      </Box>
    </FormSection>
  );
}; 